import './Icon_User.css';
import {ReactComponent as UserIcon} from './Icons_Person_Outline_brand.svg'
function Icon_User() {
  return (
    <div className='icon-container-user'>
      <UserIcon className="user-svg" />
    </div>
  );
}

export default Icon_User;